var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AlertBox',{attrs:{"customClass":'pt-1 ma-0 pb-0',"color":_vm.skyColor,"msg":_vm.msgInfo,"visible":true}})}
var staticRenderFns = []

export { render, staticRenderFns }